import { devMode } from '../../util/env'
import { buildQueryString } from '../../util/string'
import { NONCE } from '../../shared/constants'

export const SUBMIT = 'ksk001/downloadExpose/SUBMIT'
export const SUBMIT_SUCCESS = 'ksk001/downloadExpose/SUBMIT_SUCCESS'
export const SUBMIT_FAILURE = 'ksk001/downloadExpose/SUBMIT_FAILURE'

export const initialState = {
  error: false,
  success: false,
  isSubmitting: false,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SUBMIT:
      return {
        ...state,
        isSubmitting: true,
        error: false,
      }
    case SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: payload.success,
      }
    case SUBMIT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: payload.error,
      }
    default:
      return state
  }
}

export const submit = () => (dispatch, getState) => {
  const state = getState()
  const id = state.estatePage.estateData.id

  const query = buildQueryString({ id })

  dispatch({
    type: SUBMIT,
  })

  return fetch(`/wp-json/dhsv/v1/user/download-expose?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.status + ': ' + response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if ('success' in json) {
          dispatch({
            type: SUBMIT_SUCCESS,
            payload: {
              success: json.success,
            },
          })
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error.message,
        },
        type: SUBMIT_FAILURE,
      })
      throw error
    })
}
